import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_OBTENER_PERSONAL;
async function getPersons() {
  const bodyParams = {
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { getPersons };
